import React, {forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState} from 'react';
import Accordion from '@material-ui/core/Accordion';
import PersonRoundedIcon from '@material-ui/icons/PersonRounded';
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccordionDetails from "@material-ui/core/AccordionDetails";
import UserDetails from "./UserDetails/UserDetails";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from '@material-ui/icons/EditRounded';
import DeleteIcon from '@material-ui/icons/DeleteRounded';
import SaveIcon from '@material-ui/icons/SaveRounded';
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import Button from "@material-ui/core/Button";
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from "@material-ui/core/TextField";
import './style.scss'
import {AppContext} from "../../../../Utils/AppContext";
import Input from "@material-ui/core/Input";
import uuid from "uuid";
import _ from "lodash";
import AreYouSureDialog from "../../../../Utils/AreYouSureDialog/AreYouSureDialog";
import MessengerOrdersHistoryContainer from "../../../../../Redux/containers/MessengerOrdersHistoryContainer";
import MessengerOrdersOwesSummary from "./MessengerProfile/MessengerOrdersOwesSummary/MessengerOrdersOwesSummary";
import MessengerManualOwesSummary from "./MessengerProfile/MessengerManualOwesSummary/MessengerManualOwesSummary";
import * as permissionTypes from "../../../../../Utils/Permissions/PermissionTypes";


const fieldsInfo = [
    {
        "name": "phoneNumber",
        "displayName": "מספר טלפון",
        "type": "text"
    },
    {
        "name": "citizenshipId",
        "displayName": "תעודת זהות",
        "type": "text"
    },
    {
        "name": "email",
        "displayName": "דוא\"ל",
        "type": "text"
    },
    {
        "name": "address",
        "displayName": "כתובת מגורים",
        "type": "text"
    },
    {
        "name": "businessNumber",
        "displayName": "ח\"פ",
        "type": "text"
    },
    {
        "name": "employType",
        "displayName": "סוג התקשרות",
        "type": "options",
        "options": [
            {
                "displayName": "שכיר",
                "value": "employee"
            },
            {
                "displayName": "עצמאי",
                "value": "independent"
            },
            {
                "displayName": "חברת שליחויות",
                "value": "courierCompany"
            }
        ]
    },
    {
        "name": "employmentStatus",
        "displayName": "סטטוס העסקה",
        "type": "options",
        "options": [
            {
                "displayName": "פעיל",
                "value": "active"
            },
            {
                "displayName": "לא פעיל",
                "value": "inactive"
            },
            {
                "displayName": "מוקפא",
                "value": "frozen"
            }
        ]
    },
    {
        "name": "vehicleType",
        "displayName": "כלי רכב",
        "type": "options",
        "options": [
            {
                "displayName": "אופנוע",
                "value": "motorcycle"
            },
            {
                "displayName": "מכונית",
                "value": "car"
            },
            {
                "displayName": "אופניים חשמליים",
                "value": "electricBicycle"
            },
            {
                "displayName": "אופניים",
                "value": "bicycle"
            },
            {
                "displayName": "קורקינט חשמלי",
                "value": "electricScooter"
            },
            {
                "displayName": "קורקינט",
                "value": "scooter"
            }
        ]
    },
    {
        "name": "vehicleNumber",
        "displayName": "מספר רכב",
        "type": "text"
    },
    {
        "name": "licenseExpiration",
        "displayName": "תוקף רישיון",
        "type": "date"
    },
    {
        "name": "insuranceCompany",
        "displayName": "חברת ביטוח",
        "type": "text"
    },
    {
        "name": "insuranceNumber",
        "displayName": "מספר פוליסת ביטוח",
        "type": "text"
    },
    {
        "name": "posCourierId",
        "displayName": "מזהה שליח בקופה",
        "type": "text"
    }
];

const UserViewEdit = forwardRef((props, ref) => {
    const appContext = useContext(AppContext);
    const [profilesText, setProfilesText] = useState();
    const [isUserDetailsExpanded, setUserDetailsExpand] = useState(true);
    const [isOrderSummaryExpanded, setOrderSummaryExpand] = useState(true);
    const [isMessengerOrdersOwesExpanded, setMessengerOrdersOwesExpand] = useState(true);
    const [isMessengerManualOwesExpanded, setMessengerManualOwesExpand] = useState(true);
    const [isEditEnabled, setEditEnabled] = useState(false);
    const [userMode, setUserMode] = useState();
    const [user, setUser] = useState();
    const [userProfiles, setUserProfiles] = useState([]);
    const [relevantFields, setRelevantFields] = useState([]);
    const [isUserProfilesError, setUserProfilesError] = useState(false);
    const [isUserNameError, setUserNameError] = useState(false);
    const [isSureDialogOpen, setSureDialogOpen] = useState(false);
    const [errorFieldsSet, setErrorFieldsSet] = useState(new Set());
    const messengerOrdersHistoryRef = useRef();

    function getUserProfilesToText(user, profiles) {
        const userProfiles = Object.keys(user.profiles).map(profileName => profiles.find(profile => profile.name === profileName));
        userProfiles.sort((a, b) => b.level - a.level);
        const userProfileNames = userProfiles.map(userProfile => userProfile.displayName);

        let text = "";

        for (let i = 0; i < userProfileNames.length; i++) {
            if (i === 0)
                text = userProfileNames[0];
            else if (i === userProfileNames.length - 1)
                text += ` ו${userProfileNames[i]}`;
            else
                text += `, ${userProfileNames[i]}`
        }

        return text;
    }

    function onUserDetailsExpandChange(isExpanded) {
        if (!isEditEnabled)
            setUserDetailsExpand(isExpanded);
    }

    function onUserNameChanged(newName) {
        changeUser({...user, name: newName});

        if (newName && isUserNameError)
            setUserNameError(false);
    }

    function onFieldValueChange(fieldName, newValue) {
        const newUser = {...user};

        newUser[fieldName] = newValue;

        if (newValue && errorFieldsSet.has(fieldName))
            setErrorFieldsSet(new Set([...errorFieldsSet].filter(fn => fn !== fieldName)));

        setUser(newUser);
    }

    function onEditUserClicked() {
        setEditEnabled(true);
        setUserDetailsExpand(true);
    }

    function onRemoveUserClicked() {
        setSureDialogOpen(true);
    }

    function onSureDeleteUser() {
        props.deleteUser(user.id);

        if (props.onDeletedUser)
            props.onDeletedUser();

        setSureDialogOpen(false);
    }

    function onNotSureDeleteUser() {
        setSureDialogOpen(false);
    }

    function onCancelEditUserClick() {
        if (userMode === "new") {
            setUserMode();

            if (props.onCancelAddUser)
                props.onCancelAddUser();
        }

        changeUser(props.user);
        setEditEnabled(false);
        setErrorFieldsSet(new Set());
    }

    function onSaveEditUserClick() {
        let isError = false;

        if (Object.keys(user.profiles).length === 0) {
            setUserProfilesError(true);

            isError = true;
        }

        if (!user.name) {
            setUserNameError(true);

            isError = true;
        }

        const invalidRequiredFieldNames = validateUserFields();

        if (invalidRequiredFieldNames.length > 0) {
            setErrorFieldsSet(new Set(invalidRequiredFieldNames));

            isError = true;
        }

        if (isError)
            return;

        if (userMode === "new") {
            props.addUser(user);
            setUserMode("existing");
        } else
            props.editUser(user);

        setEditEnabled(false);
    }

    function onAutocompleteValuesChange(newValues) {
        setUserProfiles(newValues);

        const newUser = {...user, profiles: {...user.profiles}};

        for (let profile of newValues) {
            if (!(profile.name in newUser.profiles))
                newUser.profiles[profile.name] = {};
        }

        const newProfilesSet = new Set(newValues.map(profile => profile.name));

        for (let profileName of Object.keys(user.profiles)) {
            if (!newProfilesSet.has(profileName))
                delete newUser.profiles[profileName];
        }

        setUser(newUser);

        if (isUserProfilesError && newValues.length > 0)
            setUserProfilesError(false);
    }

    function changeUser(newUser) {
        setErrorFieldsSet(new Set());
        setUser(newUser);

        if (newUser && newUser.profiles)
            setUserProfiles(Object.keys(newUser.profiles)
                .map(profileName => props.permittedProfiles.find(profile => profile.name === profileName))
                .filter(profile => profile));
        else
            setUserProfiles([]);
    }

    function validateUserFields() {
        const invalidRequiredFieldNames = [];

        for (let field of relevantFields) {
            if (field.isRequired && !user[field.name])
                invalidRequiredFieldNames.push(field.name);
        }

        return invalidRequiredFieldNames;
    }

    function onCredit() {
        messengerOrdersHistoryRef.current.refreshOrders();
    }

    function prepareForNewUser() {
        changeUser({
            "id": uuid.v4(),
            "name": "",
            "bid": appContext.bid,
            "profiles": {}
        });

        setEditEnabled(true);
    }

    useEffect(() => {
        if (user && props.profiles) {
            setProfilesText(getUserProfilesToText(user, props.profiles));

            const profilesToFields = {};

            for (let profile of props.profiles) {
                const profileToFields = {};

                for (let field of profile.fields) {
                    profileToFields[field.name] = {
                        isRequired: field.isRequired || false
                    };
                }

                profilesToFields[profile.name] = profileToFields;
            }

            const userProfileNames = Object.keys(user.profiles);

            const newRelevantFields = [];

            for (let fieldInfo of fieldsInfo) {
                let fieldFromProfiles = null;

                for (let profileName of userProfileNames) {
                    if (fieldInfo.name in profilesToFields[profileName]) {
                        const fieldFromCurrentProfile = profilesToFields[profileName][fieldInfo.name];

                        if (!fieldFromProfiles)
                            fieldFromProfiles = fieldFromCurrentProfile;
                        else if (!fieldFromProfiles.isRequired && fieldFromCurrentProfile.isRequired)
                            fieldFromProfiles.isRequired = true;
                    }
                }

                if (fieldFromProfiles)
                    newRelevantFields.push({...fieldInfo, ...fieldFromProfiles});
            }

            setRelevantFields(newRelevantFields);
        }
    }, [props.profiles, user]);

    useEffect(() => {
        if (user !== props.user) {
            changeUser(props.user);
            setEditEnabled(false);
            setUserDetailsExpand(true);
            setOrderSummaryExpand(true);
            setMessengerOrdersOwesExpand(true);
        }
    }, [props.user]);

    useEffect(() => {
        if (props.userMode === "new") {
            prepareForNewUser();
        }

        setUserMode(props.userMode)
    }, [props.userMode]);

    useImperativeHandle(ref, () => ({
        newUser() {
            prepareForNewUser();
        }
    }));

    if (!user && userMode !== "new")
        return (
            <div className="user-view user-view-no-user">
                <PersonRoundedIcon/>
                <div className="no-user-text">
                    בחר משתמש כדי לצפות בפרטיו
                </div>
            </div>
        );

    const isWhileMission = _.get(props.user, "profiles.messenger.isWhileMission");

    return (
        <div className="user-view">
            <div className="edit-user-buttons-container">
                {
                    isEditEnabled ?
                        <React.Fragment>
                            <Button className="save-edit-user-button" size="medium" color="primary"
                                    onClick={onSaveEditUserClick}
                                    variant="contained">
                                <SaveIcon/>&nbsp;{userMode === "new" ? "הוסף משתמש" : "שמור שינויים"}
                            </Button>
                            <Button className="cancel-edit-user-button" size="medium" color="primary"
                                    onClick={onCancelEditUserClick}
                                    variant="contained">
                                {userMode === "new" ? "בטל הוספה" : "בטל עריכה"}
                            </Button>
                        </React.Fragment>
                        :
                        <div>
                            <Tooltip arrow title="ערוך משתמש" aria-label="Edit">
                                <IconButton className="edit-user-button" aria-label="Edit"
                                            onClick={onEditUserClicked}>
                                    <EditIcon/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip arrow
                                     title={isWhileMission ? `השליח במהלך משימה, בטל או סיים את המשימה כדי למחוק את המשתמש` : 'מחק משתמש'}
                                     aria-label="Remove">
                                <span>
                                    <IconButton className="remove-user-button" aria-label="Remove"
                                                onClick={onRemoveUserClicked}
                                                disabled={isWhileMission}>
                                        <DeleteIcon/>
                                    </IconButton>
                                </span>
                            </Tooltip>

                            <AreYouSureDialog open={isSureDialogOpen}
                                              onYes={onSureDeleteUser}
                                              onNo={onNotSureDeleteUser}
                            />
                        </div>
                }
            </div>
            <div className="user-title-container">
                <div className="user-name-container">
                    {
                        isEditEnabled ?
                            <div className="user-name-input-container">
                                {
                                    !user.name ?
                                        <div className="user-name-input-required-sign">*</div>
                                        :
                                        null
                                }
                                <Input placeholder="שם העובד"
                                       value={user.name}
                                       onChange={e => onUserNameChanged(e.target.value)}
                                       error={isUserNameError}
                                       className="user-name-input"/>
                            </div>
                            :
                            <div className="user-name-text editable-text">{user.name}</div>
                    }
                </div>
                <div className="profiles-container">
                    {
                        isEditEnabled ?
                            <div className="profiles-input-container">
                                {
                                    userProfiles.length === 0 ?
                                        <div className="profiles-input-required-sign">*</div>
                                        :
                                        null
                                }
                                <Autocomplete
                                    multiple
                                    id="tags-standard"
                                    options={props.permittedProfiles}
                                    getOptionLabel={(option) => option.displayName}
                                    value={userProfiles}
                                    onChange={(e, newValues) => onAutocompleteValuesChange(newValues)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            className="profiles-input"
                                            variant="standard"
                                            placeholder="תפקידים"
                                            error={isUserProfilesError}
                                        />
                                    )}
                                />
                            </div>
                            :
                            <div className="profiles-text">
                                {profilesText}
                            </div>
                    }
                </div>
            </div>
            <div className="user-contents">
                <div
                    className={"user-details-container user-content" + (isEditEnabled ? " user-details-container-edit" : "")}>
                    <Accordion expanded={isUserDetailsExpanded}
                               onChange={(e, isExpanded) => onUserDetailsExpandChange(isExpanded)}>
                        <AccordionSummary
                            expandIcon={isEditEnabled ? null : <ExpandMoreIcon/>}
                            aria-controls="panel1a-content"
                        >
                            פרטי העובד
                        </AccordionSummary>
                        <AccordionDetails>
                            <UserDetails user={user}
                                         isEditEnabled={isEditEnabled}
                                         fields={relevantFields}
                                         errorFields={errorFieldsSet}
                                         onFieldValueChange={onFieldValueChange}/>
                        </AccordionDetails>
                    </Accordion>
                </div>
                {
                    "messenger" in user.profiles && !isEditEnabled ?
                        <div className="messenger-profile">
                            {
                                props.business.isMessengersOrdersOweEnabled && appContext.permissions.isPermitted(permissionTypes.VIEW_MESSENGERS_OWES) ?
                                    <div
                                        className="user-content">
                                        <Accordion expanded={isMessengerOrdersOwesExpanded}
                                                   onChange={(e, isExpanded) => setMessengerOrdersOwesExpand(isExpanded)}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon/>}
                                                aria-controls="panel1a-content"
                                            >
                                                זיכויי הזמנות
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <MessengerOrdersOwesSummary messenger={user} onCredit={onCredit}/>
                                            </AccordionDetails>
                                        </Accordion>
                                    </div>
                                    :
                                    null
                            }
                            {
                                props.business.isMessengersManualOweEnabled && appContext.permissions.isPermitted(permissionTypes.VIEW_MESSENGERS_OWES) ?
                                    <div
                                        className="user-content">
                                        <Accordion expanded={isMessengerManualOwesExpanded}
                                                   onChange={(e, isExpanded) => setMessengerManualOwesExpand(isExpanded)}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon/>}
                                                aria-controls="panel1a-content"
                                            >
                                                חובות
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <MessengerManualOwesSummary messenger={user}/>
                                            </AccordionDetails>
                                        </Accordion>
                                    </div>
                                    :
                                    null
                            }
                            <div
                                className="user-content">
                                <Accordion expanded={isOrderSummaryExpanded}
                                           onChange={(e, isExpanded) => setOrderSummaryExpand(isExpanded)}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                    >
                                        היסטוריית הזמנות
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <MessengerOrdersHistoryContainer ref={messengerOrdersHistoryRef}
                                                                         messenger={user}/>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        </div>
                        :
                        null
                }
            </div>
        </div>
    );
});

export default UserViewEdit;
